import React from "react";
import { Box, Stack, Typography, TextField, InputAdornment } from "@mui/material";
import Iconify from "../../../../components/iconify";

interface PickupDateTimeProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
  time: string | null;
  setTime: (time: string | null) => void;
  dateError?: string;
  timeError?: string;
}

const PickupDateTime: React.FC<PickupDateTimeProps> = ({ 
  date, 
  setDate, 
  time, 
  setTime,
  dateError,
  timeError
}) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value ? new Date(e.target.value) : null);
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTime(e.target.value || null);
  };


  const formattedDate = date ? date.toISOString().split('T')[0] : '';

  return (
    <Box sx={{ mb: 2, width: '100%', p: 1 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Pickup
      </Typography>
      <Stack direction="row" spacing={3} alignItems="center">
        
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography variant="body1" sx={{ mr: 2 }}>
            Date:
          </Typography>
          <TextField
            type="date"
            value={formattedDate}
            onChange={handleDateChange}
            variant="outlined"
            fullWidth
            required
            error={!!dateError}
            helperText={dateError}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              
              endAdornment: (
                <InputAdornment position="end">
                 
                </InputAdornment>
              ),
            }}
          />
        </Box>

        
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography variant="body1" sx={{ mr: 2 }}>
            Time:
          </Typography>
          <TextField
            type="time"
            value={time || ''}
            onChange={handleTimeChange}
            variant="outlined"
            fullWidth
            required
            error={!!timeError}
            helperText={timeError}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              
              endAdornment: (
                <InputAdornment position="end">
                  
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default PickupDateTime;